import { render, staticRenderFns } from "./BuildInspectVars.vue?vue&type=template&id=a13ef794"
import script from "./BuildInspectVars.vue?vue&type=script&lang=js"
export * from "./BuildInspectVars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports